import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (userId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/user/${userId}`);
